import React, { useState } from 'react'
import PropTypes from 'prop-types'
import * as Styled from './TreatmentOptions.styles'
import { Accordion, TabBar } from '../index'
import {
  Tooltip,
  Grid,
  OpeningHours,
  OpeningIndicator,
  Icon,
  CalculateRouteBtn,
} from '../../atoms'

/**
 * @returns {*}
 * @constructor
 */
const TreatmentOptions = ({ items }) => {
  const [selectedData, setSelectedData] = useState(items[0])

  const handleTabSelect = (id) => {
    // get department data by id
    const result = items.filter(({ hospitalId }) => hospitalId === id)

    if (result.length > 0) {
      setSelectedData(result[0])
    }
  }

  return (
    <Styled.TreatmentOptionsComponent>
      <Grid container>
        <Grid item xs={ 12 } md={ 4 }>
          <TabBar
            data={ items }
            onTabSelect={ handleTabSelect }
            selectedId={ selectedData.hospitalId }
          />
        </Grid>
        <Grid item xs={ 12 } md={ 8 }>
          {selectedData.options &&
            selectedData.options.map((optionData, index) => {
              const {
                openingIndicator,
                openingHours,
                highlightedInfos,
                infos,
                name,
                phone,
                address,
                coordinates,
                distance,
              } = optionData.details

              return (
                <Accordion
                  key={ `${ selectedData.hospitalId }_${ index }` }
                  label={ optionData.type }
                  type={ 'UNDERLINED' }
                  className={ 'accordion-option' }
                  open={ index === 0 }>
                  <div className={ 'wrapper' }>
                    <div className={ 'content-container' }>
                      <div className={ 'content-header' }>
                        {/* TITLE */}
                        <h4 className={ 'h4 headline-alternative' }>{name}</h4>

                        {/* ADDRESS and DISTANCE*/}
                        <span className={ 'address-container' }>
                          {address && (
                            <span>
                              <Icon className='icon-f-home contact-icon' />
                              {address.street}
                              {address.streetAddition &&
                              address.streetAddition !== ''
                                ? ` ${ address.streetAddition }`
                                : ''}
                              , {address.zip} {address.city}
                            </span>
                          )}
                          {distance && (
                            <span className={ 'distance' }>
                              <Icon className='icon-f-map-marker location-icon' />
                              {distance}
                            </span>
                          )}
                        </span>

                        {/* PHONE and ROUNTING */}
                        <span className={ 'phone-route-container' }>
                          {phone && (
                            <span>
                              <Icon className='icon-f-phone-handset contact-icon' />
                              <a href={ `tel:${ phone }` }>{phone}</a>
                            </span>
                          )}
                          {coordinates && (
                            <CalculateRouteBtn
                              marker={ coordinates }
                              type={ 'LINK' }
                              className={ 'route-button' }
                            />
                          )}
                        </span>
                      </div>
                      <div className={ 'content-details' }>
                        {/* Accordion with custom tigger element */}
                        <Accordion
                          type={ 'CUSTOM-TRIGGER' }
                          triggerComponentInstance={
                            openingIndicator && (
                              <OpeningIndicator
                                untilMsg={ openingIndicator.message }
                                type={ openingIndicator.state }
                              />
                            )
                          }>
                          <div className={ 'accordion-content-container' }>
                            {openingHours && (
                              <OpeningHours
                                openingHours={ openingHours }
                                showTimeNotice={ true }
                                className={ 'spacing-bottom' }
                              />
                            )}
                            {highlightedInfos &&
                              highlightedInfos.map((info, index) => (
                                <p key={ index }>
                                  <b>{info}</b>
                                </p>
                              ))}
                            {infos &&
                              infos.map((info, index) => (
                                <p className={ 'text-table' } key={ index }>
                                  <span className={ 'text-table-title' }>
                                    {info.title}
                                  </span>
                                  <span className={ 'text-table-copy' }>
                                    {info.copy}
                                    {info.tooltip && (
                                      <Tooltip
                                        tooltipId={ `info-tooltip-${ index }` }
                                        infoIconId={ `info-icon-${ index }` }
                                        dialogTitle={ info.title }
                                        className={ 'text-table-tooltip' }>
                                        {info.tooltip}
                                      </Tooltip>
                                    )}
                                  </span>
                                </p>
                              ))}
                          </div>
                        </Accordion>
                      </div>
                    </div>
                  </div>
                </Accordion>
              )
            })}
        </Grid>
      </Grid>
    </Styled.TreatmentOptionsComponent>
  )
}

TreatmentOptions.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      hospitalId: PropTypes.string,
      name: PropTypes.string,
      treatments: PropTypes.shape({
        cases: PropTypes.number,
      }),
    })
  ),
}

export default TreatmentOptions
